import React, { createContext, useContext } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import useObjectDefinitions from '../hooks/useObjectDefinitions';

const DataObjectContext = createContext(null);

export function useDataObject() {
  return useContext(DataObjectContext);
}

/**
 * Wraps child routes and resolves :objectSlug param to an objectDefinitionId.
 * Provides the resolved objectDefinition via context so child pages
 * can read objectDefinitionId without knowing about slugs.
 */
export default function DataObjectSlugResolver({ children }) {
  const { objectSlug } = useParams();
  const { loading, getBySlugPlural } = useObjectDefinitions();

  if (loading) return null;

  // "pipelines" is a special route, not an object slug
  if (objectSlug === 'pipelines') {
    return children;
  }

  const match = getBySlugPlural(objectSlug);
  if (!match) {
    return <Navigate to="/data/companies" replace />;
  }

  return (
    <DataObjectContext.Provider value={match}>
      {children}
    </DataObjectContext.Provider>
  );
}
